/**
 * Returns the hash params of an url
 *
 * @param hash
 * @returns {{}}
 */
function hashParams(hash = null) {
	if (hash === null) {
		hash = location.hash;
	}

	// remove # from string
	if (hash[0] === "#") {
		hash = hash.substr(1);
	}

	let params = {};

	hash.split("&").forEach(param => {
		let matches = /^([^=]+)(=(.+))?$/.exec(param);

		if (matches) {
			params[matches[1]] = matches[3] || true;
		}
	});

	return params;
}

/**
 * Decodes HTML entities
 *
 * @param str
 * @returns {string|*|void|XML}
 */
function decodeHtmlEntity(str) {
	return str.replace(/&#([a-z0-9]+);/gi, function (match, dec) {
		return String.fromCharCode(parseInt("0" + dec));
	});
}

/**
 * Encodes HTML entities
 *
 * @param str
 * @returns {string}
 */
function encodeHtmlEntity(str) {
	let buf = [];
	for (let i = str.length - 1; i >= 0; i--) {
		buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
	}
	return buf.join('');
}

/**
 * Transforms an object into a query string
 *
 * @param obj
 * @param urlEncode
 * @returns {*}
 */
function toQueryString(obj, urlEncode = false) {
	if (!obj) return null;

	const flattenObj = (x, path = []) => {
		const result = [];
		Object.keys(x).forEach((key) => {
			if (!Object.prototype.hasOwnProperty.call(x, key)) return;
			if (x[key] == undefined) return;
			const newPath = path.slice();
			newPath.push(key);
			let vals = [];
			if (typeof x[key] === 'object') {
				vals = flattenObj(x[key], newPath);
			} else {
				vals.push({path: newPath, val: x[key]});
			}
			vals.forEach((v) => {
				return result.push(v);
			});
		});
		return result;
	};

	let parts = flattenObj(obj);

	parts = parts.map((varInfo) => {
		if (varInfo.path.length === 1) {
			varInfo.path = varInfo.path[0]; // eslint-disable-line no-param-reassign
		} else {
			const first = varInfo.path[0];
			const rest = varInfo.path.slice(1);
			varInfo.path = `${first}[${rest.join('][')}]`; // eslint-disable-line no-param-reassign
		}
		return varInfo;
	});

	const queryString = parts.map((varInfo) => {
		return `${varInfo.path}=${varInfo.val}`;
	}).join('&');

	if (urlEncode) {
		return encodeURIComponent(queryString);
	}

	return queryString;
}

module.exports = {
	toQueryString,
	encodeHtmlEntity,
	decodeHtmlEntity,
	hashParams
};
